<template>
	<div :class="`${customStyle === true ? 'count-down' : 'count__time__box'} box_h flex_align_center`">
		<span>{{ hh }}</span>
		<span>{{ h }}</span>
		<b>:</b>
		<span>{{ mm }}</span>
		<span>{{ m }}</span>
		<b>:</b>
		<span>{{ ss }}</span>
		<span>{{ s }}</span>
	</div>
</template>

<script>
export default {
	props: {
		// 倒计时time.time剩余时间,单位是秒数
		time: {
			type: Object,
			required: true,
		},
		// 不使用原样式
		customStyle: {
			type: Boolean,
		},
	},
	name: "countDown",
	data() {
		return {
			hh: 0, //开奖倒计时小时十位
			h: 0, //
			mm: 0,
			m: 0,
			ss: 0,
			s: 0,
			countTime: 0,
		};
	},
	watch: {
		time(val) {
			clearInterval(this.setTimeFun);
			if (val.state) {
				this.countTime = val.time;
				this.setInervalue();
				this.sscopenTimeDispose();
			}
		},
		countTime(val) {
			if (val === 0) {
				this.$emit("upTimeData");
			}
		},
	},
	methods: {
		//生成时间执行
		sscopenTimeDispose() {
			let that = this;
			that.setTimeFun = setInterval(() => {
				let num = Number(that.countTime);
				if (num > 0) {
					that.countTime -= 1;
					that.setInervalue();
				} else {
				}
			}, 1000);
		},
		//时间处理
		setInervalue() {
			let that = this;
			let num = Number(that.countTime);
			let timeh = Math.floor(num / 3600); //小时
			let minute = Math.floor(num / 60) - timeh * 60; //分钟
			let timem = Number(num % 60); //秒
			that.hh = Math.floor(Number(timeh) / 10);
			that.h = Number(timeh) % 10;
			that.mm = Math.floor(Number(minute) / 10);
			that.m = Number(minute) % 10;
			that.ss = Math.floor(Number(timem) / 10);
			that.s = Number(timem) % 10;
		},
	},
	beforeDestroy() {
		clearInterval(this.setTimeFun);
		clearInterval(this.showSetIner);
	},
};
</script>

<style lang="scss" scoped>
.count__time__box {
	margin-top: 2px;
	span {
		font-family: "LiquidCrystal-Bold";
		font-size: 40px;
		color: #535d76;
		background-color: #fff;
		display: flex;
		align-items: center;
		padding-top: 5px;
		&:nth-child(1) {
			border-radius: 8px 0 0 8px;
			padding-left: 10px;
		}
		&:nth-child(2) {
			border-radius: 0 8px 8px 0;
			padding-right: 5px;
		}
		&:nth-child(4) {
			border-radius: 8px 0 0 8px;
			padding-left: 10px;
		}
		&:nth-child(5) {
			border-radius: 0 8px 8px 0;
			padding-right: 5px;
		}
		&:nth-child(7) {
			border-radius: 8px 0 0 8px;
			padding-left: 10px;
		}
		&:nth-child(8) {
			border-radius: 0 8px 8px 0;
			padding-right: 5px;
		}
	}

	b {
		display: inline-block;
		font-size: 48px;
		font-weight: bold;
		color: #fff;
		margin: -15px 8px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/countDown.vue